import { COURSES_CALENDAR_HOUR_ROW_COUNT } from "../../constants/courses-calendar.constants";

export const COURSES_CALENDAR_TIME_PARSE_RADIX = 10;

export const ALL_COURSES_CALENDAR_HOUR_INDICES: number[] = Array.from(
  { length: COURSES_CALENDAR_HOUR_ROW_COUNT },
  (_, i) => i,
);
